<template>
  <div class="table-responsive ms-5 me-5">
    <table class="table">
      <tbody>
        <tr>
          <th>Material</th>
          <th>Especificación</th>
          <th>Presentación</th>
          <th>Nombre</th>
          <th>Precio</th>
        </tr>
        <tr v-for="profile in profiles" :key="profile.key">
          <td>{{ profile.material }}</td>
          <td>{{ profile.specification }}</td>
          <td>{{ profile.presentation }}</td>
          <td>{{ profile.name }}</td>
          <td>{{ profile.priceId["value"] }}</td>
          <td>
            <button class="btn btn-danger me-2"
              @click.prevent="viewProfileypes(profile.id, profile.name, profile.specification)">
              Visualizar
            </button>
            <button class="btn btn-danger" @click.prevent="editProfile(profile.id)">
              Editar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      profiles: [],
      profile_id: 0,
    };
  },
  methods: {
    viewProfileypes(profileId, profileName, profileSpecification) {
      this.$emit("sendMainProfileIdForTypes", { profileId, profileName, profileSpecification });
    },
    editProfile(profileId) {
      this.$emit("sendMainProfileIdForEdit", profileId);
    },
  },
  beforeMount() {
    axios
      .get(RUTA_SERVIDOR + "api/profile/list", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.profiles = res.data))
      //   .then((res) => console.log(this.profiles))
      .catch((err) => console.log(`There has been an error ${err}`));
  },
};
</script>
<style></style>